// Initializes the AdSense global array if it doesn't exist
if (typeof window !== 'undefined') {
  window.adsbygoogle = window.adsbygoogle || [];
}

export const loadAds = () => {
  console.log("Ads utility initialized.");
};